import { SidebarLogo } from './Logo';

export default function Sidebar({ user, page, setPage, onLogout }) {
  const adminNavItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '\ud83d\udcca', section: 'Overview' },
    { id: 'employees', label: 'Employees', icon: '\ud83d\udc65', section: 'People' },
    { id: 'tracking', label: 'Progress Tracking', icon: '\ud83d\udcc8', section: 'People' },
    { id: 'videos', label: 'Training', icon: '\ud83c\udfac', section: 'Content' },
    { id: 'assignments', label: 'Assignments', icon: '\ud83d\udccb', section: 'Content' },
    { id: 'quizzes', label: 'Quizzes', icon: '\u2753', section: 'Content' },
  ];

  const employeeNavItems = [
    { id: 'dashboard', label: 'My Dashboard', icon: '\ud83d\udcca' },
    { id: 'videos', label: 'Training', icon: '\ud83c\udfac' },
    { id: 'assignments', label: 'Assignments', icon: '\ud83d\udccb' },
    { id: 'quizzes', label: 'Quizzes', icon: '\u2753' },
  ];

  const isAdmin = user?.role === 'admin';
  const navItems = isAdmin ? adminNavItems : employeeNavItems;
  const sections = isAdmin ? ['Overview', 'People', 'Content'] : null;

  return (
    <div className="sidebar">
      <div className="sidebar-logo"><SidebarLogo /></div>
      <div className="sidebar-nav">
        {sections ? (
          sections.map(sec => (
            <div key={sec}>
              <div className="nav-section">{sec}</div>
              {navItems.filter(n => n.section === sec).map(n => (
                <div key={n.id} className={`nav-item ${page === n.id ? 'active' : ''}`} onClick={() => setPage(n.id)}>
                  <span className="nav-icon">{n.icon}</span>{n.label}
                </div>
              ))}
            </div>
          ))
        ) : (
          navItems.map(n => (
            <div key={n.id} className={`nav-item ${page === n.id ? 'active' : ''}`} onClick={() => setPage(n.id)}>
              <span className="nav-icon">{n.icon}</span>{n.label}
            </div>
          ))
        )}
      </div>
      <div className="sidebar-footer">
        <div style={{ marginBottom: 8, color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
          {'\ud83d\udc64'} {user?.email || 'User'}
        </div>
        <button className="logout-btn" onClick={onLogout}>Sign out</button>
      </div>
    </div>
  );
}
